import { useEffect, useState } from "react";

export const useAutoHideUI = (condition: boolean, autoHideDelay = 3000) => {
  const [isUiHidden, setIsUiHidden] = useState<boolean>(false);
  let timer: NodeJS.Timeout;

  const onMouseMove = () => {
    setIsUiHidden(false);
    clearTimeout(timer);
    timer = setTimeout(() => setIsUiHidden(true), autoHideDelay);
  };

  const removeListeners = () => {
    document.removeEventListener("mousemove", onMouseMove);
    clearTimeout(timer);
  };

  useEffect(() => {
    if (condition) {
      document.addEventListener("mousemove", onMouseMove);
      setIsUiHidden(true);
    } else {
      removeListeners();
      setIsUiHidden(false);
    }

    return () => {
      removeListeners();
    };
  }, [condition]);

  return {
    isUiHidden,
  };
};
